import React, { PureComponent } from 'react';
import { UTLabel } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';

import styles from './styles.module.scss';
import phoneImage from './assets/phone.png';

class Home extends PureComponent {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <UTLabel xxlarge semibold white className={styles.title}>
            {message('Home:title')}
          </UTLabel>
          <UTLabel large white>
            {message('Home:subtitle')}
          </UTLabel>
        </div>
        <img src={phoneImage} alt="phone" className={styles.phone} />
      </div>
    );
  }
}

export default Home;
